import React from 'react'
import Button from './button'
import { MAIN_INFO_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

const InfoButton = props => {
    const { icon = 'info', theme = 'info_button', onClick, onDispatchClick, alt } = props

    return (
        <Button
            tabIndex={MAIN_INFO_BUTTON_INDEX}
            onDispatchClick={onDispatchClick}
            onClick={onClick}
            theme={theme}
            icon={icon}
            alt={alt || 'info'}
            {...props}
        />
    )
}

export default InfoButton
